module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-timetal__container marg-1-top"
  }, [_c('h4', {
    staticClass: "uppercase marg-1-bottom"
  }, [_vm._v("Fag")]), _vm._v(" "), (_vm.personaleUdenKorrekteOplysninger.length === 0 && _vm.fagUdenKorrekteOplysninger.length === 0) ? _c('h3', [_vm._v("Alt er udfyldt\n    korrekt")]) : _vm._e(), _vm._v(" "), (_vm.personaleUdenKorrekteOplysninger.length > 0 || _vm.fagUdenKorrekteOplysninger.length > 0) ? _c('div', {
    staticClass: "d-attention"
  }, [_c('svg', {
    staticClass: "tw-icon icon-important",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    staticClass: "primary",
    attrs: {
      "d": "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "secondary",
    attrs: {
      "d": "M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Følgende fag mangler oplysninger")]), _vm._v(" "), _c('p', [_vm._v("Gå til step 3. \"Fag\" og tilføj oplysningerne eller slet faget, hvis faget ikke skal indberettes.")]), _vm._v(" "), _c('table', {
    staticClass: "d-table d-table__borders"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.fagUdenKorrekteOplysninger), function(fag, key) {
    return _c('tr', {
      key: fag.fag_id
    }, [_c('td', [_vm._v(_vm._s(fag.klasse) + ", " + _vm._s(fag.fag_navn))]), _vm._v(" "), _c('td', _vm._l((fag.errors), function(error, errorIdx) {
      return _c('span', {
        staticClass: "fag-errors"
      }, [_vm._v(_vm._s(error)), (errorIdx + 1 < fag.errors.length) ? [_vm._v(", ")] : _vm._e()], 2)
    }), 0)])
  }), 0)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Fag")]), _vm._v(" "), _c('th', [_vm._v("Fejl")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f8b2a84!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/KompetenceIndberetning/Resume/IndberetFag.vue
// module id = 1875
// module chunks = 1